import React, { Fragment, useState } from "react";
import axios from "axios";

import { getSession, setSession } from "../../utils/localStorage";
import { CONNECT, CONNECT_CLIENT } from "../../utils/definitions";

import { XIcon } from "@heroicons/react/outline";
import gausta from "../../services/gausta"

import Input from "../input";
import DotsAnimation from "../../components/dotsAnimation";
import getClassName from "../../utils/classnames";
import Modal from "../modal";

const forms = {
  login: "login",
  recover: "recover",
  reset: "reset",
  completed: "completed",
};

const formDefaultState = {
  email: "",
  password: "",
  temporarypassword: "",
  newpassword: "",
  repeatnewpassword: "",
};

const defaultColors = {
    blocksBackground: "#ffffff",
    greyText: "#75757D",
    blueText: "#3560DA"
}


const ResetPasswordCompleted = ({ setDisplayedForm, closeFn, moduleData, colors }) => {
  return (
    <>
      <div>
        <div className="flex row items-center">
          <span className="flex-1 text-lg font-semibold">
            {moduleData?.newpassword}
          </span>
          <button
            onClick={closeFn}
            className={
              "h-10 w-12 border-[#EAEAF2] border-w border-2 flex items-center justify-center rounded-lg"
            }
          >
            <XIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="mt-6">
        <p className="text-sm font-semibold mb-2" style={{color: colors?.greyText}}>
          {moduleData?.resetPassword}
        </p>
      </div>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          className={`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium ${getClassName("button", "primary")} disabled:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm`}
          onClick={() => setDisplayedForm(forms["login"])}
        >
          {moduleData?.buttonContinueText}
        </button>
      </div>
    </>
  );
};

const ResetPassword = ({ form, setForm, closeFn, setDisplayedForm, moduleData, colors }) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [samePassword, setSamePassword] = useState(true);

  const onSubmit = () => {
    if(form.newpassword !== form.repeatnewpassword){
      setSamePassword(false);
    }
    else{
      setSamePassword(true);
      setLoading(true);
      axios
        .post(`${CONNECT}/checkout/change-password`, {
          client: CONNECT_CLIENT,
          session: getSession().uuid,
          email: form.email,
          temporaryPassword: form.temporarypassword,
          password: form.newpassword,
        })
        .catch(() => console.log("error"))
        .then((response) => {
          console.log(response)
          if(response.status === 206){
            setErrorMessage(moduleData.temporaryPasswordError);
          }
          else if(response.status === 200){
            setErrorMessage('');
            setDisplayedForm(forms["completed"]);
            const currentForm = { ...form };
            currentForm.password = "";
            currentForm.temporarypassword = "";
            currentForm.newpassword = "";
            currentForm.repeatnewpassword = "";
            setForm(currentForm);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <>
      <div>
        <div className="flex row items-center">
          <span className="flex-1 text-lg font-semibold">
            {moduleData?.newPasswordDescription}
          </span>
          <button
            onClick={closeFn}
            className={
              "h-10 w-12 border-[#EAEAF2] border-w border-2 flex items-center justify-center rounded-lg"
            }
          >
            <XIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="mt-6">
        <p className="text-sm font-semibold mb-2" style={{color: colors?.greyText}}>
          {moduleData?.temporaryPasswordDescription} {form.email}
          <br />
          <br />
         {moduleData?.temporaryPasswordDescription2}
        </p>
        <Input
          label={moduleData?.temporaryPasswordLabel}
          id="input_temporarypassword"
          value={form.temporarypassword}
          onChange={(e) => {
            e.preventDefault();
            setForm({ ...form, temporarypassword: e.target.value });
          }}
          autocomplete="new-password"
        />
        {errorMessage ? <div className="text-red-500 text-sm font-semibold">{errorMessage}</div> : null}
        <p className="text-sm font-semibold mb-2" style={{color: colors?.greyText}}>
          {moduleData?.belowPassword}
        </p>
        <div className="flex flex-col gap-2">
          <Input
            type="password"
            label={moduleData?.newPasswordLabel}
            id="input_newpassword"
            value={form.newpassword}
            onChange={(e) => {
              e.preventDefault();
              setForm({ ...form, newpassword: e.target.value });
            }}
            autocomplete="new-password"
          />
          <Input
            type="password"
            label={moduleData?.repeatPasswordLabel}
            id="input_repeat_newpassword"
            value={form.repeatnewpassword}
            onChange={(e) => {
              e.preventDefault();
              setForm({ ...form, repeatnewpassword: e.target.value });
            }}
            autocomplete="new-password"
          />
          {!samePassword ? <div className="text-red-500 text-sm font-semibold">{moduleData.newPasswordMatchError}</div> : null}
        </div>
      </div>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          className={`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium ${getClassName("button", "primary")} disabled:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm`}
          onClick={onSubmit}
        >
           {loading ? <DotsAnimation className="w-9 h-4" /> : moduleData?.buttonContinueText}
        </button>
      </div>
    </>
  );
};

const RecoverPassword = ({ form, setForm, closeFn, setDisplayedForm, moduleData, colors }) => {
  const [loading, setLoading] = useState(false);
  const isContinueButtonEnabled = form.email !== "";

  const onSubmit = () => {
    setLoading(true);
    axios
      .post(`${CONNECT}/checkout/temporary-password`, {
        client: CONNECT_CLIENT,
        session: getSession().uuid,
        email: form.email,
      })
      .catch(() => console.log("error"))
      .then((response) => {
        setDisplayedForm(forms["reset"]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div>
        <div className="flex row items-center">
          <span className="flex-1 text-lg font-semibold">
            {moduleData?.newPasswordDescription}
          </span>
          <button
            onClick={closeFn}
            className={
              "h-10 w-12 border-[#EAEAF2] border-w border-2 flex items-center justify-center rounded-lg"
            }
          >
            <XIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="mt-6">
        <p className="text-sm font-semibold mb-2" style={{color: colors?.greyText}}>
          {moduleData?.newPasswordDescription2}
        </p>
        <Input
          label={moduleData?.email}
          id="input_email"
          value={form.email}
          onChange={(e) => {
            e.preventDefault();
            setForm({ ...form, email: e.target.value });
          }}
          autocomplete="email"
        />
      </div>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          className={`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium ${getClassName("button", "primary")} disabled:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm`}
          onClick={onSubmit}
          disabled={!isContinueButtonEnabled}
        >
          {loading ? <DotsAnimation className="w-9 h-4" /> : moduleData?.buttonContinueText}
        </button>
      </div>
    </>
  );
};

const LoginForm = ({ form, setForm, closeFn, setDisplayedForm, onFinishLogin, moduleData, colors, showButtonContinue }) => {
  const [loading, setLoading] = useState(false);
  const [ error, setError ] = useState(false);
  const [ errorType, setErrorType ] = useState("wrongPassword");
  const isLoginButtonEnabled = form.email && form.password;

  const onSubmit = () => {
    setLoading(true);
    axios
      .post(`${CONNECT}/checkout/login`, {
        client: CONNECT_CLIENT,
        session: getSession().uuid,
        data: {
          email: form.email,
          password: form.password,
        },
      })
      .catch((e) => {
        setError(true);
        setErrorType("unexpectedError");
        setLoading(false);
      })
      .then((response) => {
        if (response.data && response.data.customer) {
          setSession({
            ...getSession(),
            updated_at: response.data.updated_at,
            customer: response.data.customer,
            purchaser: response.data.purchaser,
          });
          if (onFinishLogin) onFinishLogin();
          closeFn();
        } else {
          setError(true);
          setLoading(false);
          if (response.data && response.data.no_account) {
            setErrorType("accountNotFound");
          } else {
            setErrorType("wrongPassword");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div>
        <div className="flex row items-center">
          <span className="flex-1 text-lg font-semibold">{moduleData?.login}</span>
          <button
            onClick={closeFn}
            className={
              "h-10 w-12 border-[#EAEAF2] border-w border-2 flex items-center justify-center rounded-lg"
            }
          >
            <XIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className="mt-6">
        {error ? (
          <span className={"text-sm	font-semibold	text-[#e80003] block mb-4"}>
            {moduleData[errorType]}
          </span>
        ) : null}
        <div className="flex flex-col gap-2 mb-2">
          <Input
            label={moduleData?.email}
            id="input_email"
            value={form.email}
            onChange={(e) => {
              e.preventDefault();
              setForm({ ...form, email: e.target.value });
            }}
            autocomplete="email"
          />
          <Input
            type="password"
            label={moduleData?.password}
            id="input_password"
            value={form.password}
            onChange={(e) => {
              e.preventDefault();
              setForm({ ...form, password: e.target.value });
            }}
            autocomplete="current-password"
          />
        </div>
        <div className="flex justify-end">
          <button
            className="text-sm font-extrabold ml-auto"
            onClick={() => setDisplayedForm(forms["recover"])}
            style={{color: colors?.blueText}}
          >
            {moduleData?.forgotPassword}
          </button>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex flex-col gap-2">
        <button
          type="button"
          className={`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm ${getClassName("button", "primary")} disabled:opacity-80`}
          onClick={onSubmit}
          disabled={!isLoginButtonEnabled}
        >
          {loading ? <DotsAnimation className="w-9 h-4" /> : moduleData.loginButton}
        </button>
        {
          showButtonContinue ?
          <button onClick={closeFn} className={`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm ${getClassName("button", "secondary")} disabled:opacity-80`}>{moduleData.continueButton}</button>
          : null
        }
      </div>
    </>
  );
};

const LoginModal = ({ show, closeFn, onFinishLogin, moduleData = {}, colors = defaultColors, showButtonContinue = false, doNotAssignGaustaTranslations = false }) => {
  const [displayedForm, setDisplayedForm] = useState(forms["login"]);
  const [form, setForm] = useState(formDefaultState);

  if (!doNotAssignGaustaTranslations) {
  Object.assign(moduleData, {
    newpassword: gausta.translations.translate('newpassword'),
    resetPassword: gausta.translations.translate('resetPassword'),
    buttonContinueText: gausta.translations.translate('buttonContinueText'),
    newPasswordDescription: gausta.translations.translate('newPasswordDescription'),
    newPasswordDescription2: gausta.translations.translate('newPasswordDescription2'),
    temporaryPasswordDescription: gausta.translations.translate('temporaryPasswordDescription'),
    temporaryPasswordDescription2: gausta.translations.translate('temporaryPasswordDescription2'),
    temporaryPasswordLabel: gausta.translations.translate('temporaryPasswordLabel'),
    belowPassword: gausta.translations.translate('belowPassword'),
    newPasswordLabel: gausta.translations.translate('newPasswordLabel'),
    repeatPasswordLabel: gausta.translations.translate('repeatPasswordLabel'),
    email: gausta.translations.translate('email'),
    login: gausta.translations.translate('login'),
    password: gausta.translations.translate('password'),
    forgotPassword: gausta.translations.translate('forgotPassword'),
    accountNotFound: gausta.translations.translate('accountNotFound'),
    wrongPassword: gausta.translations.translate('wrongPassword'),
    unexpectedError: gausta.translations.translate('unexpectedError'),
    continueButton: gausta.translations.translate('continueButton'),
  });
  }

  const onClose = () => {
    // Modal is closed with a css transition, so login form should be reset after transition ends
    setTimeout(() => {
      setDisplayedForm(forms["login"]);
      setForm(formDefaultState);
    }, 300);
    closeFn();
  };

  return(
    <Modal closeFn={onClose} open={show} size={"small"}>
      {displayedForm === "login" && (
        <LoginForm
          form={form}
          setForm={setForm}
          closeFn={onClose}
          setDisplayedForm={setDisplayedForm}
          onFinishLogin={onFinishLogin}
          moduleData={moduleData}
          colors={colors}
          showButtonContinue={showButtonContinue}
        />
      )}
      {displayedForm === "recover" && (
        <RecoverPassword
          form={form}
          setForm={setForm}
          closeFn={onClose}
          setDisplayedForm={setDisplayedForm}
          moduleData={moduleData}
          colors={colors}
        />
      )}
      {displayedForm === "reset" && (
        <ResetPassword
          form={form}
          setForm={setForm}
          closeFn={onClose}
          setDisplayedForm={setDisplayedForm}
          moduleData={moduleData}
          colors={colors}
        />
      )}
      {displayedForm === "completed" && (
        <ResetPasswordCompleted
          setDisplayedForm={setDisplayedForm}
          closeFn={onClose}
          moduleData={moduleData}
          colors={colors}
        />
      )}
    </Modal>
  )
};

export default LoginModal;
